import { ModuleUserExtended } from 'app/library/module-user/models/module-user.extended.model';
import { IStudentWidgetContentQuery } from '../interfaces/student-widget-content.interface';

// @dynamic
export class StudentWidgetContent {
    id: string;
    name: string;
    type: string;
    maxVisibleLength: number;
    content: ModuleUserExtended[];

    constructor(query?: IStudentWidgetContentQuery) {
        if (query) {
            this.id = query.id.toString();
            this.name = query.name;
            this.type = query.type;
            this.maxVisibleLength = query.max_visible_length;
            this.content = query.content.map((query) => new ModuleUserExtended(query));
        }
    }
}
